<template>
    <div>
        <nav-bar />
        <div class="main">
            <section
                class="hero-section ptb-100 background-img"
                style="
                    background: url('img/hero.jpg') no-repeat center center / cover;
                "
            >
                <div class="container">
                    <div class="row align-items-center justify-content-center">
                        <div class="col-md-9 col-lg-7">
                            <div class="page-header-content text-white text-center">
                                <h1 class="text-white mb-0">Terms of Service</h1>
                                <div class="custom-breadcrumb">
                                    <ol
                                        class="breadcrumb d-inline-block bg-transparent list-inline py-0"
                                    >
                                        <li class="list-inline-item breadcrumb-item">
                                            <router-link
                                                class="nav-link page-scroll bold matchBtn"
                                                to="/"
                                                >{{ $t("home") }}</router-link
                                            >
                                        </li>
                                        <li
                                            class="list-inline-item breadcrumb-item active"
                                        >
                                            Terms of Service
                                        </li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="gray-light-bg ptb-100">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-md-10 col-lg-9">
                            <div class="terms-content">
                                <h2 class="mb-4">Terms of Service</h2>
                                <p>
                                    These Terms of Service ("Terms") govern your
                                    access to and use of the website and services
                                    of Star Jasmine Employment Centre ("we", "us"
                                    or "our"), a licensed employment agency in
                                    Hong Kong (Licence No. 81643). By accessing
                                    or using our website and services, you agree
                                    to be bound by these Terms. If you do not
                                    agree to these Terms, please do not use our
                                    website or services.
                                </p>

                                <h4 class="mt-5 mb-3">1. Our Services</h4>
                                <p>
                                    We provide employment agency services,
                                    including but not limited to the recruitment,
                                    referral and placement of domestic helpers
                                    and related home services. Information on
                                    this website is provided for general
                                    reference only and does not constitute an
                                    offer or guarantee of any particular
                                    placement, candidate or outcome.
                                </p>

                                <h4 class="mt-5 mb-3">2. Use of the Website</h4>
                                <p>
                                    You agree to use this website only for lawful
                                    purposes. You must not:
                                </p>
                                <ul>
                                    <li>
                                        use the website in any way that breaches
                                        any applicable law or regulation of Hong
                                        Kong or elsewhere;
                                    </li>
                                    <li>
                                        submit false, misleading or fraudulent
                                        information;
                                    </li>
                                    <li>
                                        interfere with, damage or disrupt the
                                        website, its servers or networks; or
                                    </li>
                                    <li>
                                        copy, reproduce or redistribute any part
                                        of the website without our prior written
                                        consent.
                                    </li>
                                </ul>

                                <h4 class="mt-5 mb-3">
                                    3. Accounts and Information You Provide
                                </h4>
                                <p>
                                    Where you register an account or submit
                                    information to us (for example through
                                    enquiry, matching or application forms), you
                                    are responsible for ensuring that the
                                    information you provide is accurate, complete
                                    and up to date, and for keeping your account
                                    credentials confidential. Your personal data
                                    will be handled in accordance with our
                                    <router-link to="/privacy"
                                        >Privacy Policy</router-link
                                    >
                                    and the Personal Data (Privacy) Ordinance
                                    (Cap. 486) of Hong Kong.
                                </p>

                                <h4 class="mt-5 mb-3">4. Fees and Engagements</h4>
                                <p>
                                    Fees, charges and the terms of any employment
                                    agency engagement will be set out in the
                                    separate service agreement between you and
                                    us. In the event of any inconsistency between
                                    these Terms and a signed service agreement,
                                    the service agreement prevails in respect of
                                    that engagement.
                                </p>

                                <h4 class="mt-5 mb-3">5. Intellectual Property</h4>
                                <p>
                                    All content on this website, including text,
                                    graphics, logos, images and software, is
                                    owned by or licensed to us and is protected
                                    by applicable intellectual property laws. You
                                    may view and print content for your personal,
                                    non-commercial use only.
                                </p>

                                <h4 class="mt-5 mb-3">6. Third-Party Content</h4>
                                <p>
                                    This website may contain links to third-party
                                    websites or services that are not owned or
                                    controlled by us. We are not responsible for
                                    the content, policies or practices of any
                                    third-party websites or services, and a link
                                    does not imply our endorsement.
                                </p>

                                <h4 class="mt-5 mb-3">7. Disclaimer</h4>
                                <p>
                                    While we take reasonable care in preparing
                                    the content of this website, it is provided
                                    on an "as is" and "as available" basis
                                    without warranties of any kind, whether
                                    express or implied, including as to accuracy,
                                    completeness, reliability or fitness for a
                                    particular purpose. We do not warrant that
                                    the website will be uninterrupted, secure or
                                    error-free.
                                </p>

                                <h4 class="mt-5 mb-3">
                                    8. Limitation of Liability
                                </h4>
                                <p>
                                    To the maximum extent permitted by law, we
                                    shall not be liable for any indirect,
                                    incidental, special or consequential loss or
                                    damage arising out of or in connection with
                                    your use of, or inability to use, this
                                    website. Nothing in these Terms excludes or
                                    limits any liability that cannot be excluded
                                    or limited under the laws of Hong Kong.
                                </p>

                                <h4 class="mt-5 mb-3">9. Changes to These Terms</h4>
                                <p>
                                    We may revise these Terms from time to time
                                    by posting the updated version on this page.
                                    Your continued use of the website after any
                                    changes are posted constitutes your
                                    acceptance of the revised Terms.
                                </p>

                                <h4 class="mt-5 mb-3">10. Governing Law</h4>
                                <p>
                                    These Terms are governed by and construed in
                                    accordance with the laws of the Hong Kong
                                    Special Administrative Region, and you agree
                                    to submit to the non-exclusive jurisdiction
                                    of the courts of Hong Kong.
                                </p>

                                <h4 class="mt-5 mb-3">11. Contact Us</h4>
                                <p>
                                    If you have any questions about these Terms,
                                    please contact us at
                                    <a href="mailto:cs@hkhomeservices.com.hk"
                                        >cs@hkhomeservices.com.hk</a
                                    >
                                    or by telephone at 2559 9223.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <site-footer />
        </div>
    </div>
</template>

<script>
import NavBar from "../views/commons/NavBar";
import SiteFooter from "../views/index-five/SiteFooter";

export default {
    name: "TermsPage",
    components: {
        NavBar,
        SiteFooter,
    },
};
</script>

<style scoped>
.terms-content p,
.terms-content li {
    font-size: 15px;
    line-height: 1.8;
    color: #4a5568;
}
.terms-content ul {
    padding-left: 24px;
    margin-bottom: 1rem;
}
.terms-content li {
    margin-bottom: 8px;
}
</style>
